var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('lateral-menu',{attrs:{"id":"sidebar-wrapper"}}),_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('div',{staticClass:"page-content"},[_c('Header'),_c('Main')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }